module.exports = __webpack_public_path__ + "img/newlogo.f34eb02c.svg";